module.exports = __webpack_public_path__ + "img/2.99377630.jpg";